import React, { useState } from 'react';

const normalizeState = (name) => {
    if (!name) return '';
    const upper = name.trim().toUpperCase();
    if (upper === 'ANDHRA PRADASH') return 'ANDHRA PRADESH';
    if (upper === 'ANDAMAN NICOBAR') return 'ANDAMAN AND NICOBAR';
    if (upper === 'KOLKATA') return 'WEST BENGAL';
    if (upper === 'PONDICHERRY') return 'PUDUCHERRY';
    return upper;
};

const normalizeDistrict = (name) => {
    if (!name) return '';
    const upper = name.trim().toUpperCase();
    if (upper === 'TRICHY' || upper === 'TIRUCHIRAPPALLI' || upper === 'TRICHIRAPALLI') return 'TIRUCHIRAPPALLI';
    if (upper === 'KANCHEEPURAM' || upper === 'KANCHIPURAM') return 'KANCHIPURAM';
    if (upper === 'VILLUPURAM' || upper === 'VILUPPURAM') return 'VILLUPURAM';
    if (upper === 'KANIYAKUMARI' || upper === 'KANNIYAKUMARI' || upper === 'KANYAKUMARI' || upper === 'NAGERCOIL') return 'KANIYAKUMARI';
    if (upper === 'TIRUPUR' || upper === 'TIRUPPUR' || upper === 'TRIPUR') return 'TIRUPUR';
    if (upper === 'THIRUVALLUR' || upper === 'TIRUVRLLUR' || upper === 'TIRUVALLUA') return 'TIRUVALLUR';
    if (upper === 'THIRUVANNAMALAI' || upper === 'TIRUVANNAMALAI' || upper === 'TIRUVATUR') return 'TIRUVANNAMALAI';
    if (upper === 'VIRUDHU NAGAR' || upper === 'VIRUDHUNAGAR') return 'VIRUDHUNAGAR';
    if (upper === 'THOOTHUKUDI' || upper === 'THOOTHUKKUDI' || upper === 'THOO TUKUDI') return 'THOOTHUKUDI';
    if (upper === 'PUDUKKOTTAI' || upper === 'PUDUKOTTAI') return 'PUDUKKOTTAI';
    if (upper === 'DINDUGUL' || upper === 'DINDIGUL') return 'DINDIGUL';
    if (upper === 'TANJAVUR' || upper === 'THANJAVUR') return 'THANJAVUR';
    return upper;
};

const INDIA_STATES = [
  { name: 'TAMIL NADU', displayName: 'Tamil Nadu', top: '83%', left: '38%' },
  { name: 'KARNATAKA', displayName: 'Karnataka', top: '72%', left: '32%' },
  { name: 'KERALA', displayName: 'Kerala', top: '83%', left: '32%' },
  { name: 'TELANGANA', displayName: 'Telangana', top: '61%', left: '40%' },
  { name: 'MAHARASHTRA', displayName: 'Maharashtra', top: '56%', left: '32%' },
  { name: 'WEST BENGAL', displayName: 'West Bengal', top: '46%', left: '64%' },
  { name: 'ANDHRA PRADESH', displayName: 'Andhra Pradesh', top: '70%', left: '42%' },
  { name: 'ANDAMAN AND NICOBAR', displayName: 'Andaman & Nicobar', top: '83%', left: '78%' },
  { name: 'GUJARAT', displayName: 'Gujarat', top: '46%', left: '18%' },
  { name: 'UTTAR PRADESH', displayName: 'Uttar Pradesh', top: '36%', left: '48%' },
  { name: 'HARYANA', displayName: 'Haryana', top: '28%', left: '35%' },
  { name: 'ASSAM', displayName: 'Assam', top: '36%', left: '77%' },
  { name: 'ODISHA', displayName: 'Odisha', top: '52%', left: '55%' },
  { name: 'JAMMU KASHMIR', displayName: 'Jammu & Kashmir', top: '14%', left: '35%' },
  { name: 'DELHI', displayName: 'Delhi', top: '30%', left: '38%' },
  { name: 'PUDUCHERRY', displayName: 'Puducherry', top: '80%', left: '42%' },
  { name: 'JHARKHAND', displayName: 'Jharkhand', top: '45%', left: '58%' },
  { name: 'RAJASTHAN', displayName: 'Rajasthan', top: '36%', left: '26%' },
  { name: 'UTTARAKHAND', displayName: 'Uttarakhand', top: '25%', left: '42%' },
  { name: 'BIHAR', displayName: 'Bihar', top: '38%', left: '60%' },
  { name: 'HIMACHAL PRADESH', displayName: 'Himachal Pradesh', top: '20%', left: '38%' },
  { name: 'PUNJAB', displayName: 'Punjab', top: '24%', left: '33%' },
  { name: 'CHHATTISGARH', displayName: 'Chhattisgarh', top: '51%', left: '48%' },
  { name: 'GOA', displayName: 'Goa', top: '69%', left: '26%' },
  { name: 'SIKKIM', displayName: 'Sikkim', top: '34%', left: '65%' },
  { name: 'ARUNACHAL PRADESH', displayName: 'Arunachal Pradesh', top: '29%', left: '83%' },
  { name: 'MANIPUR', displayName: 'Manipur', top: '40%', left: '81%' },
  { name: 'MIZORAM', displayName: 'Mizoram', top: '44%', left: '80%' },
  { name: 'TRIPURA', displayName: 'Tripura', top: '43%', left: '77%' },
  { name: 'MEGHALAYA', displayName: 'Meghalaya', top: '38%', left: '74%' },
  { name: 'NAGALAND', displayName: 'Nagaland', top: '36%', left: '83%' }
];

const TN_DISTRICTS = [
  { name: 'CHENNAI', displayName: 'Chennai', top: '9%', left: '88%' },
  { name: 'TIRUVALLUR', displayName: 'Tiruvallur', top: '8%', left: '78%' },
  { name: 'COIMBATORE', displayName: 'Coimbatore', top: '50%', left: '17%' },
  { name: 'TIRUPUR', displayName: 'Tirupur', top: '48%', left: '28%' },
  { name: 'SALEM', displayName: 'Salem', top: '33%', left: '46%' },
  { name: 'KANCHEEPURAM', displayName: 'Kancheepuram', top: '15%', left: '76%' },
  { name: 'VELLORE', displayName: 'Vellore', top: '12%', left: '60%' },
  { name: 'KRISHNAGIRI', displayName: 'Krishnagiri', top: '18%', left: '41%' },
  { name: 'MADURAI', displayName: 'Madurai', top: '64%', left: '39%' },
  { name: 'DHARMAPURI', displayName: 'Dharmapuri', top: '26%', left: '46%' },
  { name: 'TIRUNELVELI', displayName: 'Tirunelveli', top: '87%', left: '29%' },
  { name: 'ERODE', displayName: 'Erode', top: '36%', left: '28%' },
  { name: 'NILGIRIS', displayName: 'Nilgiris', top: '38%', left: '12%' },
  { name: 'THENI', displayName: 'Theni', top: '65%', left: '27%' },
  { name: 'TIRUCHIRAPPALLI', displayName: 'Tiruchirappalli', top: '47%', left: '54%' },
  { name: 'RAMANATHAPURAM', displayName: 'Ramanathapuram', top: '74%', left: '54%' },
  { name: 'TIRUVARUR', displayName: 'Tiruvarur', top: '52%', left: '72%' },
  { name: 'SIVAGANGAI', displayName: 'Sivagangai', top: '64%', left: '53%' },
  { name: 'TIRUVANNAMALAI', displayName: 'Tiruvannamalai', top: '20%', left: '68%' },
  { name: 'RANIPET', displayName: 'Ranipet', top: '10%', left: '68%' },
  { name: 'KARUR', displayName: 'Karur', top: '48%', left: '40%' },
  { name: 'VIRUDHUNAGAR', displayName: 'Virudhunagar', top: '72%', left: '35%' },
  { name: 'THOOTHUKUDI', displayName: 'Thoothukudi', top: '82%', left: '40%' },
  { name: 'THANJAVUR', displayName: 'Thanjavur', top: '50%', left: '63%' },
  { name: 'NAMAKKAL', displayName: 'Namakkal', top: '40%', left: '43%' },
  { name: 'DINDIGUL', displayName: 'Dindigul', top: '56%', left: '36%' },
  { name: 'CUDDALORE', displayName: 'Cuddalore', top: '36%', left: '72%' },
  { name: 'KANIYAKUMARI', displayName: 'Kaniyakumari', top: '94%', left: '25%' },
  { name: 'NAGAPATTINAM', displayName: 'Nagapattinam', top: '54%', left: '77%' },
  { name: 'CHENGALPATTU', displayName: 'Chengalpattu', top: '19%', left: '84%' },
  { name: 'TIRUPATTUR', displayName: 'Tirupattur', top: '18%', left: '53%' },
  { name: 'VILLUPURAM', displayName: 'Villupuram', top: '25%', left: '72%' },
  { name: 'ARIYALUR', displayName: 'Ariyalur', top: '42%', left: '67%' },
  { name: 'PERAMBALUR', displayName: 'Perambalur', top: '40%', left: '59%' },
  { name: 'TENKASI', displayName: 'Tenkasi', top: '80%', left: '27%' },
  { name: 'PUDUKKOTTAI', displayName: 'Pudukkottai', top: '56%', left: '57%' },
  { name: 'KALLAKURICHI', displayName: 'Kallakurichi', top: '32%', left: '62%' },
  { name: 'MAYILADUTHURAI', displayName: 'Mayiladuthurai', top: '44%', left: '77%' }
];

const InteractiveMaps = ({ stats, onMapClick }) => {
    const [hoveredState, setHoveredState] = useState(null);
    const [hoveredDistrict, setHoveredDistrict] = useState(null);

    // Process India State Stats
    const stateCounts = {};
    if (stats.state_stats) {
        stats.state_stats.forEach(item => {
            const normalized = normalizeState(item.state);
            stateCounts[normalized] = (stateCounts[normalized] || 0) + (item.count || 0);
        });
    }

    // Process TN District Stats
    const districtCounts = {};
    if (stats.district_stats) {
        stats.district_stats.forEach(item => {
            const normalized = normalizeDistrict(item.district);
            districtCounts[normalized] = (districtCounts[normalized] || 0) + (item.count || 0);
        });
    }

    // Sort States by count descending
    const sortedStates = Object.entries(stateCounts)
        .map(([name, count]) => {
            const match = INDIA_STATES.find(s => s.name === name);
            return {
                name: match ? match.displayName : name,
                count
            };
        })
        .filter(item => item.count > 0)
        .sort((a, b) => b.count - a.count);

    // Sort Districts by count descending
    const sortedDistricts = Object.entries(districtCounts)
        .map(([name, count]) => {
            const match = TN_DISTRICTS.find(d => d.name === name);
            return {
                name: match ? match.displayName : name,
                count
            };
        })
        .filter(item => item.count > 0)
        .sort((a, b) => b.count - a.count);

    return (
        <div className="bg-white shadow rounded-lg p-6 mb-8">
            <h3 className="text-lg font-semibold text-gray-800 mb-6 border-b pb-3">Geographic Distribution</h3>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* India Map */}
                <div className="flex flex-col items-center">
                    <h4 className="font-bold text-gray-700 mb-4 text-center">India Member Statistics</h4>
                    <div className="relative border rounded-lg shadow-sm max-w-full w-[530px] h-[530px] bg-sky-50/20 overflow-hidden">
                        <img 
                            src="/images/India-States-Map.png" 
                            alt="India Map" 
                            className="w-full h-full object-contain"
                        />
                        
                        {/* Elegant Glassmorphic Hover Info Panel */}
                        <div className="absolute top-4 left-4 bg-white/95 text-gray-800 py-3 px-4 rounded-xl shadow-xl border border-gray-200 backdrop-blur-md z-20 min-w-[190px] transition-all duration-200">
                            {hoveredState ? (
                                <div>
                                    <div className="text-xs text-gray-500 uppercase tracking-wider font-bold">Active Region</div>
                                    <div className="font-extrabold text-black text-lg mt-1">{hoveredState.displayName}</div>
                                    <div className="text-xl font-black mt-1.5 text-red-600">{hoveredState.count} <span className="text-xs font-semibold text-gray-500">members</span></div>
                                </div>
                            ) : (
                                <div className="text-gray-500 italic py-2 text-center text-sm font-medium">Hover over a pin for details</div>
                            )}
                        </div>
                        
                        {/* Overlay State Pins */}
                        {INDIA_STATES.map(state => {
                            const count = stateCounts[state.name] || 0;
                            if (count === 0) return null;
                            
                            return (
                                <button 
                                    key={state.name}
                                    className="absolute transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer focus:outline-none transition-transform active:scale-95"
                                    style={{ top: state.top, left: state.left, zIndex: 10 }}
                                    onClick={() => onMapClick(state.displayName, null)}
                                    onMouseEnter={() => setHoveredState({ displayName: state.displayName, count })}
                                    onMouseLeave={() => setHoveredState(null)}
                                >
                                    {/* Glowing Pulse Dot */}
                                    <div className="relative flex items-center justify-center">
                                        <span className="animate-ping absolute inline-flex h-8 w-8 rounded-full bg-blue-400 opacity-75"></span>
                                        <span className="relative inline-flex rounded-full h-6 w-6 bg-blue-600 border border-white items-center justify-center text-xs font-bold text-white shadow-md">
                                            {count > 99 ? '99+' : count}
                                        </span>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* Tamil Nadu Map */}
                <div className="flex flex-col items-center">
                    <h4 className="font-bold text-gray-700 mb-4 text-center">Tamil Nadu District Statistics</h4>
                    <div className="relative border rounded-lg shadow-sm max-w-full w-[530px] h-[530px] bg-sky-50/20 overflow-hidden">
                        <img 
                            src="/images/Tamil_Nadu_districts_map.webp" 
                            alt="Tamil Nadu Districts Map" 
                            className="w-full h-full object-contain"
                        />
                        
                        {/* Elegant Glassmorphic Hover Info Panel */}
                        <div className="absolute top-4 left-4 bg-white/95 text-gray-800 py-3 px-4 rounded-xl shadow-xl border border-gray-200 backdrop-blur-md z-20 min-w-[190px] transition-all duration-200">
                            {hoveredDistrict ? (
                                <div>
                                    <div className="text-xs text-gray-500 uppercase tracking-wider font-bold">Active District</div>
                                    <div className="font-extrabold text-black text-lg mt-1">{hoveredDistrict.displayName}</div>
                                    <div className="text-xl font-black mt-1.5 text-red-600">{hoveredDistrict.count} <span className="text-xs font-semibold text-gray-500">members</span></div>
                                </div>
                            ) : (
                                <div className="text-gray-500 italic py-2 text-center text-sm font-medium">Hover over a pin for details</div>
                            )}
                        </div>
                        
                        {/* Overlay District Pins */}
                        {TN_DISTRICTS.map(dist => {
                            const count = districtCounts[dist.name] || 0;
                            if (count === 0) return null;
                            
                            return (
                                <button 
                                    key={dist.name}
                                    className="absolute transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer focus:outline-none transition-transform active:scale-95"
                                    style={{ top: dist.top, left: dist.left, zIndex: 10 }}
                                    onClick={() => onMapClick('Tamil Nadu', dist.displayName)}
                                    onMouseEnter={() => setHoveredDistrict({ displayName: dist.displayName, count })}
                                    onMouseLeave={() => setHoveredDistrict(null)}
                                >
                                    {/* Glowing Pulse Dot */}
                                    <div className="relative flex items-center justify-center">
                                        <span className="animate-ping absolute inline-flex h-8 w-8 rounded-full bg-green-400 opacity-75"></span>
                                        <span className="relative inline-flex rounded-full h-6 w-6 bg-green-600 border border-white items-center justify-center text-xs font-bold text-white shadow-md">
                                            {count > 99 ? '99+' : count}
                                        </span>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Detailed Lists Section */}
            <div className="mt-12 border-t pt-8">
                <h3 className="text-xl font-bold text-gray-800 mb-6 text-center lg:text-left">Detailed Breakdown</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* States List */}
                    <div className="bg-slate-50 rounded-2xl p-6 border border-gray-100">
                        <div className="flex justify-between items-center mb-4 border-b pb-3">
                            <h4 className="font-bold text-gray-800 flex items-center gap-2">
                                <span className="text-xl">🗺️</span> State-wise Statistics
                            </h4>
                            <span className="text-xs bg-blue-100 text-blue-800 font-bold px-2.5 py-1 rounded-full">
                                {sortedStates.length} Active States
                            </span>
                        </div>
                        <div className="max-h-[400px] overflow-y-auto pr-2 space-y-3 custom-scrollbar">
                            {sortedStates.length === 0 ? (
                                <p className="text-gray-500 italic text-center py-8">No state data available</p>
                            ) : (
                                sortedStates.map((state, index) => {
                                    const maxCount = sortedStates[0]?.count || 1;
                                    const percent = (state.count / maxCount) * 100;
                                    return (
                                        <div key={state.name} className="bg-white p-3 rounded-xl border border-gray-100 flex flex-col gap-2 hover:shadow-sm transition-shadow">
                                            <div className="flex justify-between items-center">
                                                <div className="flex items-center gap-3">
                                                    <span className="text-xs font-bold text-gray-400 w-5">
                                                        #{index + 1}
                                                    </span>
                                                    <span className="font-semibold text-gray-800">
                                                        {state.name}
                                                    </span>
                                                </div>
                                                <span className="font-extrabold text-blue-600 bg-blue-50 px-3 py-1 rounded-lg text-sm">
                                                    {state.count} <span className="text-[10px] font-normal text-gray-500">members</span>
                                                </span>
                                            </div>
                                            {/* Progress Bar */}
                                            <div className="w-full bg-gray-100 h-1.5 rounded-full overflow-hidden">
                                                <div 
                                                    className="bg-blue-500 h-full rounded-full transition-all duration-500" 
                                                    style={{ width: `${percent}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>

                    {/* Districts List */}
                    <div className="bg-slate-50 rounded-2xl p-6 border border-gray-100">
                        <div className="flex justify-between items-center mb-4 border-b pb-3">
                            <h4 className="font-bold text-gray-800 flex items-center gap-2">
                                <span className="text-xl">📍</span> District-wise (Tamil Nadu)
                            </h4>
                            <span className="text-xs bg-green-100 text-green-800 font-bold px-2.5 py-1 rounded-full">
                                {sortedDistricts.length} Active Districts
                            </span>
                        </div>
                        <div className="max-h-[400px] overflow-y-auto pr-2 space-y-3 custom-scrollbar">
                            {sortedDistricts.length === 0 ? (
                                <p className="text-gray-500 italic text-center py-8">No district data available</p>
                            ) : (
                                sortedDistricts.map((dist, index) => {
                                    const maxCount = sortedDistricts[0]?.count || 1;
                                    const percent = (dist.count / maxCount) * 100;
                                    return (
                                        <div key={dist.name} className="bg-white p-3 rounded-xl border border-gray-100 flex flex-col gap-2 hover:shadow-sm transition-shadow">
                                            <div className="flex justify-between items-center">
                                                <div className="flex items-center gap-3">
                                                    <span className="text-xs font-bold text-gray-400 w-5">
                                                        #{index + 1}
                                                    </span>
                                                    <span className="font-semibold text-gray-800">
                                                        {dist.name}
                                                    </span>
                                                </div>
                                                <span className="font-extrabold text-green-600 bg-green-50 px-3 py-1 rounded-lg text-sm">
                                                    {dist.count} <span className="text-[10px] font-normal text-gray-500">members</span>
                                                </span>
                                            </div>
                                            {/* Progress Bar */}
                                            <div className="w-full bg-gray-100 h-1.5 rounded-full overflow-hidden">
                                                <div 
                                                    className="bg-green-500 h-full rounded-full transition-all duration-500" 
                                                    style={{ width: `${percent}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InteractiveMaps;
